import Cookies from 'js-cookie';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IUserProfileInfo } from '../../interfaces/user-profile.interface';
import { salesforceService } from '../../services';

const findOneCookie = () =>
  createAsyncThunk('auth/findOneCookie', async (cookieName: string) => {
    const cookie = Cookies.get(cookieName);
    return cookie || null;
  });

const findUserProfile = () => createAsyncThunk('auth/findUserProfile', async (user: IUserProfileInfo) => salesforceService.userInfo(user));

export default {
  findOneCookie: findOneCookie(),
  findUserProfile: findUserProfile(),
};
